export default {
    common: {
      searchPlac: "搜尋問題、話題或人",
      bottomTitle: "噴沫屋雲AI工具",
      tip: "提示",
      sure: "確定",
      cancel: "取消",
      language: "語言",
      onlineService: "線上客服",
      del: "删除",
      edit: "編輯",
    },
    nav: {
      title: "噴沫屋AI",
      noNoTice: "沒有未讀通知",
      lookAll: "看全部",
      login: "登入",
      register: "註冊",
      set: "設定",
      logout: "退出",
      remainingPoints: "剩餘積分",
      remainingArticles: "剩餘篇數",
      recharge: "儲值",
      index: "首頁",
      mustRead: "站長必讀",
      billingMethod: "計費方式",
      adminConsole: "管理控制台",
      notice: "通知"
    },
    sidebar: {
      title: "噴沫屋 管理控制台",
      adminConsole: "帳戶管理",
      recharge: "儲值",
      webmanage: "網站管理",
      push: "介面檔案相關",
      webkeywords: "欄位與關鍵字",
      aisetting: "產生發布設定",
      test: "手動運行測試",
      data: "文章暫存庫",
      userWallet: "推薦返傭"
    },
    index: {
      topTitle: "透過關鍵字自動產出內容 自動發布",
      topSubTitle1:
        "基於呼叫OpenAI開發的ChatGpt大語言模型，按關鍵字產生相關文章，無需編寫生成規則。目前支援GPT3.5以及GPT4.0",
      topSubTitle2:
        "自動產生高度匹配的原創內容，透過我們的內建演算法，搭配最適合的SEO優化策略，智慧定時定量輸出高品質的SEO內容，讓SEO事半功倍！",
      topSubBtn: "更多功能詳解",
      topSubBtnTilte: "噴沫屋雲AI工具 - 功能詳解",
      apiKeyPlace: "請輸入要ChatGpt3.5 的api Key",
      articleKey: "文章關鍵字",
      articleKeyPlace: "請輸入要產生文章的關鍵字",
      btn: "立即生成文章",
      label1: "標題",
      label2: "關鍵字",
      label3: "TAG標籤",
      label4: "內容簡介",
      label5: "正文",
      title1: "豐富可選的SEO優化選項",
      title11:
        "系統內建業界主流SEO優化手段，包括組合標題、正文長度過濾、智慧提取標籤、關鍵字自動加粗、插入關鍵字、自動內鏈、自動配圖、主動推播等。",
      title1Tag1: "AI標題",
      title1Tag2: "AI內容",
      title1Tag3: "自訂風格",
      title1Tag4: "智慧標籤",
      title1Tag5: "關鍵字加粗",
      title1Tag6: "插入關鍵字",
      title1Tag7: "自動內鏈",
      title1Tag8: "自動配圖",
      title1Tag9: "主動推播",
      title2: "高度智慧的AI系統",
      title21:
        "採用市面最強的OPENAI語言模型，可根據用戶提供的關鍵字訊息，透過網路已有的內容，使用AI仿寫標題，並根據標題來生成文章，內容高度原創，邏輯清晰，準確度高。使用者可以透過自訂編輯產生規則，使文章更符合網站的內容要求，效果超越大部分人工編輯。",
      title22: "所以我們不只是一個生成器，更是一個功能強大的智慧網編。",
      title2Tag1: "深度學習",
      title2Tag2: "語言模型",
      title2Tag3: "AI模型",
      title2Tag4: "高度可讀",
      title2Tag5: "邏輯清晰",
      title3: "穩定可靠的自動運行生成任務",
      title31:
        "生成任務每天定時定量由伺服器自動運行，無需看管，文章生成成功後自動推送到您的網站後台。",
      title32:
        "您只需要設定好必要的參數，就可實現全託管無人值守自動更新高品質文章。",
      title33: "更多功能請註冊後體驗。",
      title3Tag1: "自動生成",
      title3Tag2: "無需掛機",
      title3Tag3: "無人值守",
      title3Tag4: "自動發布",
      title4: "支援的內容管理系統、網站建置程式/平台",
      title5: "最新行業資訊"
    },
    mustRead: {
      all: "全部",
      keepRead: "繼續閱讀",
      publishedIn: "發表於",
      searchPlac: "搜尋問題、話題或人",
      hotArticles: "熱門文章",
      generatorRelated: "生成器相關"
    },
    billingMethod: {
      rule: "產生積分消耗規則",
      rule1: "聯絡客服可取得100積分+10篇推送額度進行測試。",
      rule2: "計費分為：token消耗積分計費、推播文章計費。",
      rule3:
        "積分消耗規則：使用您自己的api key 不會收取積分。如果您沒有api key,那麼使用我們官方的api key需要扣除消耗token對應的積分。",
      rule41: "token消耗積分計費：依照產生文章消耗的token扣除對應的積分。",
      rule42: "GPT3.5積分與token比例100:50000。",
      rule43: "GPT4.0積分與token比例100:1000。",
      rule44: "依照一篇大約500字，大概需要消耗1000-1300token，扣除積分如下：",
      rule45: "GPT3.5對應扣除積分2-2.6。",
      rule46: "GPT4.0對應扣除積分100-130。",
      rule5:
        "使用GPT4.0會額外扣除40積分每篇，這是因為需要支付介面呼叫次數的費用。",
      rule6:
        "在自訂前後綴提示字添加時，token消耗會增加，限制條件越多，消耗token越多。",
      rule7:
        "推播篇數：不發佈到網站不扣除篇數。手動執行測試需要消耗一篇推播篇數。",
      rule8: "儲值比例：1元=100積分。",
      rule9:
        "OpenAI的計費規則複雜，使用本平台積分轉換可能會有偏差，建議自行申請GPT3.5或4.0的API key，這樣比較划算!"
    },
    adminConsole: {
      welcome: "歡迎您",
      changePassword: "修改密碼",
      remainingArticles: "剩餘篇數",
      rechargeArticles: "儲值篇數",
      remainingPoints: "剩餘積分",
      rechargePoints: "儲值積分",
      details: "積分收支明細",
      time: "時間",
      consumePoints: "消耗積分",
      consumeArticles: "消耗篇數",
      type: "類型",
      info: "相關資訊",
      more: "更多",
      noMore: "已無更多內容",
      website: "網站",
      jump: "跳轉",
    },
    reset: {
      title: "修改密碼",
      set: "使用者設定",
      old: "目前密碼",
      new: "新的密碼",
      sure: "確認密碼",
      submit: "提交",
      suc: "修改密碼成功"
    },
    accountsetting: {
      title: "基本資料",
      account: "帳號",
      realName: "真實姓名",
      contact: "聯絡方式",
      mobile: "手機號碼",
      email: "常用郵箱",
      submit: "提交",
      suc: "修改訊息成功"
    },
    verify: {
      title: "申請認證",
      currentState: "目前狀態",
      notCertified: "未認證",
      authenticationType: "認證類型",
      personalAuthentication: "個人認證",
      institutionalAccreditation: "機構認證",
      realName: "真實姓名",
      identityCard: "身分證號碼",
      contact: "聯絡方式",
      authDesc: "認證說明",
      accessories: "附件",
      clickUp: "點擊上傳",
      upTip: "請提交對應的身份證或組織機構代碼證件掃描",
      submit: "提交",
      suc: "修改訊息成功"
    },
    login: {
      title: "帳號密碼登入",
      loginKey: "郵件信箱 / 使用者名稱",
      passwd: "密碼",
      btn: "登入",
      rememberMe: "記住我",
      retrievePassword: "找回密碼"
    },
    addfunds: {
      title1: "選擇儲值金額（只針對沒有API Key的用戶，自有的不需購買）",
      integral: "積分",
      btn: "支付寶支付",
      title2: "選擇託管套餐（無論有沒有API Key都需要購買）",
      article: "篇文章",
      rmb: "元"
    },
    webmanage: {
      title: "網站管理",
      addWeb: "新增網站",
      batchAdd: "大量新增",
      webSearch: "網站搜尋",
      orderNumber: "序號",
      web: "網站",
      record: "記錄",
      consumeToken: "消耗Token",
      consumePoints: "消耗積分",
      bindingAPI: "綁定API",
      operate: "操作",
      openWeb: "點此開啟網站首頁",
      lookRecord: "點此查看產生記錄",
      lookFinsh: "點此查看完成狀況",
      pleaseBindAPI: "請綁定API",
      apiDown: "介面下載",
      columnSettings: "欄位設定",
      content: "內容設定",
      manualTest: "手動測試",
      articleMana: "文章管理",
      deletWeb: "刪除網站",
      selectDel: "刪除勾選",
      bindApiKey: "綁定api key",
      official: "官方",
      self: "自有",
      tipText: "免費版可能會限制呼叫頻率",
      bindPlace: "請輸入要綁定api key",
      delTip: "此操作將永久刪除網站, 是否繼續?",
      hadDel: "已取消刪除",
      delSuc: "刪除成功",
      selectContent: "請選擇內容",
      unbound: '未綁定',
    },
    addsite: {
      title: "新增網站",
      tip11: "請輸入您的網站域名，若開啟了",
      tip12: "，請選擇",
      tip13: "協議頭，否則請選擇",
      tip14: "協議頭。",
      eg: "如",
      tip21: "請將驗證文件上傳到",
      tip22: "網站根目錄",
      tip23: "，並確認可以被正常訪問，驗證完後可以刪除。",
      downFile: "下載驗證文件",
      startVerify: "開始驗證",
      submit: "提交",
      inputWeb: "請輸入域名",
      verifySuc: "驗證成功",
      addSuc: "添加成功",
      verifyTip1: "請驗證網域所有權",
      verifyTip2: "無需驗證，直接添加"
    },
    addsiteMore: {
      title: "大量新增網站",
      description: "格式說明",
      description1: "官方/key",
      description2:
        "|(欄位名稱1;欄位ID;模式;關鍵字1,關鍵字2,關鍵字3;啟動/停止)(欄位名稱2;欄位ID2;模式;關鍵字1,關鍵字2,關鍵字3;啟動/停止)(欄位名稱3;欄位ID3;模式;關鍵字1,關鍵字2,關鍵字3;啟動/停止)",
      divided: "分為",
      divided1: "網域",
      divided2: "GPT版本",
      divided3: "官方還是自有，自有需要填寫API KEY",
      divided4:
        "綁定欄位關鍵字以及產生模式：欄位名稱隨便填;對應欄目的ID;AI模式=1,自訂模式=2、關鍵字（以英文逗號分隔，可填入多個）",
      eg: "舉例",
      eg1: "(新聞欄;10;1;時事新聞,體育新聞;啟動)",
      eg2: "(科技欄;15;1;晶片,航太材料;停止)",
      eg3: "(軍事新聞;13;2;南海局勢,俄烏衝突;啟動)",
      official: "官方",
      submit: "提交",
      verifyWeb: "驗證網站",
      notVerifyWeb: "沒有可驗證的網站",
      verifyTip1: "請將驗證文件上傳到",
      verifyTip2: "網站根目錄",
      verifyTip3: "，並確認可以被正常訪問，驗證完後可以刪除。",
      verifyTip4: "(綠色表示驗證通過)",
      downloadFile: "下載驗證文件",
      validateWebsite: "開始驗證",
      addWebiste: "新增通過的網站",
      verifySuc: "驗證成功",
      addSuc: "添加成功"
    },
    push: {
      title: "取得推送介面文件",
      applicationDescription: "用途說明",
      applicationDescription1: "用於文章生成完畢後發佈到您網站。",
      applicationDescription2: "請下載",
      applicationDescription3: "發布介面",
      applicationDescription4: "文件，上傳到您網站",
      applicationDescription5: "根目錄",
      applicationDescription6: "自動發布可能會被某些",
      applicationDescription7: "防火牆",
      applicationDescription8:
        "規則攔截，如果您的伺服器開啟了防火牆，建議新增URL白名單",
      applicationDescription9: "寶塔面板防火牆怎麼加入URL白名單？",
      selectApi: "請選擇您需要的接口",
      userName: "使用者名稱",
      password: "密碼",
      description: "說明",
      description1: "請填寫您的",
      description2: "建站ABC後台",
      description3: "帳號密碼",
      subAdminLogin: "子管理員登入",
      save: "儲存",
      apiDown: "發布介面下載",
      apiTest: "發布介面測試",
      selectApi: "請選擇介面",
      selectWeb: "請選擇網站",
      apiSuc: "發布介面測試成功",
      saveSuc: "保存成功"
    },
    webkeywords: {
      title: "欄位與關鍵字",
      addColumn: "新增欄目",
      batchAddColumns: "大量新增欄目",
      columnName: "欄位名稱",
      limitTen: "最多10個字",
      columnId: "欄位ID",
      pushColumn: "要發佈的目標欄位/分類ID",
      subColumnId: "子欄ID",
      enterSubColumnId: "請輸入子欄ID",
      subColumnThree: "子欄3",
      puhsTo: "推送到",
      article: "文章",
      product: "產品",
      cancel: "取消",
      save: "儲存",
      aiMode: "AI模式",
      diyMode: "自訂模式",
      keyWord: "關鍵字",
      enterKeyWord: "請輸入您的關鍵字，可點選預覽效果",
      preview: "預覽",
      previewTitle: "預覽標題",
      wait: "預覽標題可能需要30-60秒，請等待",
      diyAdd: "自訂模組（新增欄位）",
      mode: "模式",
      hadCreatArticles: "已產生文章數",
      operate: "操作",
      state: "狀態",
      keyWordBind: "關鍵字綁定",
      delColumn: "刪除欄目",
      enabled: "已啟用",
      notEnabled: "未啟用",
      enterTitle: "請輸入標題",
      batchEnabled: "批量啟用",
      batchNotEnabled: "批量停用",
      batchDel: "批量删除",
      commonProblem: "常見問題",
      problem1: "欄位名稱和欄位ID怎麼填？有什麼影響？",
      problem11:
        "欄位名稱只是方便使用者區分不同欄目，只用於顯示，不會對生成行為產生任何影響。",
      problem12:
        "欄目ID用於發佈時將文章發到對應的欄位下，所以需要透過介面文件發佈的用戶，一定要把欄目ID填對。",
      problem13:
        "欄位名稱和欄位ID都允許重複添加，可透過此方式實現同一欄位使用多種關鍵字類型。",
      problem2: "WordPress欄位ID怎麼看？",
      problem21: "在WordPress後台，在文章模組下找到分類選單並開啟。",
      problem22: "滑鼠指向分類名稱，查看瀏覽器左下角顯示的鏈接，找到",
      problem23: "，所顯示的數字就是此欄目的ID。",
      problem3: "為什麼有的欄位生成到的文章很少？長期生成不到文章會怎麼樣？",
      problem31:
        "不同的關鍵字，網路上新增內容產生的速度不同。由於長期產生相同關鍵字，特別是關鍵字數量少、產業冷門、指定目標網站、過濾條件苛刻等條件下生成效率就會逐步下降。",
      problem32: "建議盡量多綁定關鍵字，對提升生成效率有明顯效果。",
      problem4: "如何產生指定網站、指定關鍵字的內容？",
      problem41: "建立欄目時選擇自訂模式，並綁定關鍵字。",
      problem42: "完成網站的生成發佈設定即可",
      problem5: "什麼是AI模式？什麼是自訂模式？",
      problem51:
        "AI模式：適合主關鍵字較少的產業，可以透過少量關鍵字拓展相關長尾詞產生大量文章",
      problem52:
        "自訂模式：輸入的關鍵字即時文章標題。直接呼叫輸入的關鍵字請求文章內容",
      diyBind: "自訂模組（關鍵字綁定）",
      addColumnSuc: "新增欄位成功",
      editColumnSuc: "編輯欄位成功",
      enabledTip: "此操作將永久停用該欄位, 是否繼續?",
      noEnabledTip: "此操作將永久啟用該欄位, 是否繼續?",
      delTip: "此操作將永久刪除該欄位, 是否繼續?",
      hadCancelEnabled: "已取消停用",
      hadCancelNotEnabled: "已取消啟用",
      hadCancelDel: "已取消刪除",
      enabledSuc: "啟用成功",
      notEnabledSuc: "停止成功",
      enterSaveKeyWord: "請輸入要儲存的關鍵字",
      saveSuc: "保存成功",
      enterKeyWord: "請輸入關鍵字",
      selectContetn: "請選擇內容"
    },
    massaddtype: {
      title: "大量新增欄目",
      description1:
        "格式說明：欄位名稱|欄位id|模式(1:AI，2：自訂)|關鍵字1,關鍵字2,關鍵字3.....，如：",
      description2: "股票配資|10|1|股票配資哪家好,股票配資找XXX,股票配資專業機構",
      description3:
        "，每行一個。大量新增欄位後，請注意設定關鍵字，否則無法取得內容。",
      submit: "提交",
      addSuc: "大量新增欄位成功"
    },
    test: {
      title: "手動運行測試",
      btn: "開始",
      tip11: "請選擇要測試的域名，點選",
      tip12: "按鈕啟動測試。大約需要30-60秒，請耐心等待",
      tip2: "手動生成運行中",
      tip31: "透過綁定關鍵字",
      tip32: "綁定欄目ID",
      tip33: "取得到標題",
      tip34: "產生關鍵字",
      tip35: "產生TAG標籤",
      tip36: "內容描述",
      tip37: "正文內容",
      tip38: "發布狀態",
      tip39: "點擊查看",
      tip41: "注意：本頁面是為生成",
      tip42: "測試",
      tip43: "而設計，有",
      tip44: "速度限制",
      tip45: "，如需快速生成，請開啟",
      tip46: "雲端自動運行",
      problem: "常見問題",
      problem1: "在運行生成任務之前，哪些設定是必須的？",
      problem11: "驗證網站所有權，把網站加入平台。",
      problem12:
        "設定好對應網站的欄目，填寫正確的欄目ID，每個欄位新增關鍵字，最好是多個。",
      problem13: "在生成發佈設置頁面中完成設置，點選儲存按鈕。",
      proble2: "多久才能生成到文章？",
      proble21: "每個網站首次運行生成任務，需要等待",
      proble22: "1-2分鐘",
      proble23: "不等才能生成到文章，後續運行任務會快一些。",
      proble24:
        "不同關鍵字內容豐富程度不同，盡量多加入關鍵字，可以提高生成效率。",
      proble3: "生成到文章後，如何發布文章內容到網站？",
      proble31:
        "如需自動發佈到網站，請上傳對應程式的介面文件，並把文章交付方式設為",
      proble32: "透過介面檔案發佈到我的網站後台",
      proble33: "如需手動取得文章，或需先編輯再發布，請把文章交付方式設為",
      proble34: "把文章放到文章暫存庫",
      proble4: "如何開啟生成任務？",
      proble41: "欄位與關鍵字",
      proble42: "頁面，需要設定列目的狀態為已啟用才可以進行自動生成",
      proble43: "產生發布設定",
      proble44: "頁面設有自動運行生成開關，開啟後伺服器即會自動執行生成任務。",
      pushSuc: "已發布成功",
      pushErr: "發布失敗",
      pointsConsumption: "積分消耗",
      aiModel: "使用的模型",
    },
    data: {
      title: "文章暫存庫",
      allStatus: "全部狀態",
      toEdit: "待編輯",
      hadEdit: "已編輯",
      hadPush: "已發布",
      search: "查詢",
      page: "本頁",
      all: "全部",
      head: "標題",
      status: "狀態",
      time: "時間",
      consumeToken: "消耗Token",
      consumePoints: "消耗積分",
      operate: "操作",
      del: "刪除",
      push: "發布",
      selectDel: "請選擇要刪除的記錄",
      delTip: "此操作將永久刪除該文章, 是否繼續?",
      delSuc: "刪除成功",
      hadDel: "已取消刪除",
      selectPush: "請選擇要發布的記錄",
      pushTip: "此操作將發布該文章, 是否繼續?",
      pushSuc: "發布成功",
      pushErr: "已取消發布",
      AIModelVersion: "AI模型版本",
    },
    aisetting: {
      title: "產生發布設定",
      importTemplate: "從模板匯入",
      saveTemplate: "存為模板",
      autorun: "雲端自動運行",
      autorunTip1: "雲端自動運行任務。",
      autorunTip2: "只要帳戶有積分，系統會依照您設定的時間自動運行，即使您",
      autorunTip3: "電腦關機也不影響",
      runTime: "運行時間",
      runTimeTip1: "24小時運轉(預設)",
      runTimeTip2: "指定時段運行",
      runTimeTip3: "請勾選需要運作的時段",
      clock: "點",
      getArticle: "每小時取得文章數",
      getArticleTip1: "全站發布",
      getArticleTip2: "篇/小時，各欄篇篇數隨機。",
      getArticleTip3: "僅為最大量，並不保證一定能達到",
      getArticleTip4: "，通常可達1000篇每小時(每站)，",
      contentSyle: "自訂內容風格",
      contentSyleTip1: "預設模式",
      contentSyleTip2: "專業模式",
      contentSyleTip3: "自訂模式",
      contentSyleTip4: "預設模式:系統會根據關鍵字請求內容。",
      contentSyleTip5: "舉例:以「XXXXX」為關鍵字產生一篇文章",
      contentSyleTip6:
        "專業模式:本站蒐集了網路上各領域的內容產生方式，請選擇與您網站內容相關的領域，使內容更精準。",
      contentSyleTip7: "前綴",
      contentSyleTip8: "後綴",
      contentSyleTip9: "自訂模式:您可以自訂輸入提問的前後綴來要求內容",
      contentSyleTip10: "舉例",
      contentSyleTip11: "你現在是專業的醫生，你需要以醫生的角度來幫我寫作，",
      contentSyleTip12: "以「XXXX」為關鍵字生成一篇文章",
      contentSyleTip13: "，內容需要與癌症治療相關。",
      contentSyleTip14: "紅色為前綴，藍色為後綴。",
      textLength: "正文長度選擇",
      textLengthTip1:
        "請選擇需求的正文長度（不一定能達到，取決於最終取決於AI的創作能力。）",
      textLengthTip2: "字左右",
      keyWordLimit: "單一關鍵字生成文章限制",
      keyWordLimitTip1: "每個關鍵字最多允許生成",
      keyWordLimitTip2: "篇文章。",
      keyWordLimitTip3: " 若留空或設為0，則不限篇數。 （自訂模式留空即可）",
      author: "預設作者",
      authorTip1: "總是直接使用該作者，而不會從網頁生成",
      article: "預設文章來源",
      relevance: "相關度優化",
      relevanceTip1: "內文隨機位置自動插入目前關鍵字",
      relevanceTip2: "次。",
      relevanceTip3: "當正文中出現當前關鍵字時，自動把該關鍵字加粗。",
      relevanceTip4: "在正文開頭插入文章標題。",
      relevanceTip5: "使用html標籤：",
      relevanceTip6: "，不含",
      relevanceTip7: "，例如：",
      relevanceTip8: "，留空則不使用任何標籤。",
      tags: "Tags標籤",
      tagsTip1: "智慧提取標籤，數量",
      tagsTip2: "個",
      tagsTip3: "目前產生關鍵字作標籤",
      tagsTip4: "不使用Tags標籤",
      fixedLink: "固定連結",
      fixedLinkTip1: "為正文中",
      fixedLinkTip2: "已存在的",
      fixedLinkTip3: "詞彙添加鏈接，每行一個，最多200個，格式：",
      fixedLinkTip4: "文章生成",
      fixedLinkTip5: "表示如果正文中出現",
      fixedLinkTip6: "文章生成",
      fixedLinkTip7: "這個詞，則把它連結到",
      fixedLinkTip8: "如果某個字在正文中多次出現，只在第一次出現時加入連結。",
      fixedLinkTip9: "連結可以是站內或站外的，可以是首頁或內頁，但不要包含",
      fixedLinkTip10: "符號。",
      fixedLinkTip11: "固定鏈接，每行一個",
      keywordDensity: "關鍵字密度",
      keywordDensityTip1: "從以下關鍵字隨機取",
      keywordDensityTip2: "個，插入到內文隨機位置，為0則關閉。可以是單獨的詞語如",
      keywordDensityTip3: "文章生成",
      keywordDensityTip4: "，也可以是一段html，如",
      keywordDensityTip5: "文章生成",
      keywordDensityTip6: "，每行一个，最多1万个。",
      keywordDensityTip7: "需要插入的關鍵字，每行一個",
      autoImg: "自動配圖",
      autoImgTip1: "每篇配圖",
      autoImgTip2: "幅(最多5幅)",
      autoImgTip3:
        "請在下方填寫圖片網址，系統將隨機抽取圖片，不再從網路取得。每行一個，最多2000個。",
      autoImgTip4: "自訂圖片網址，每行一個，如：",
      autoImgTip5:
        "如果圖片無法正常顯示，可能原因是網路圖片有防盜鏈設置，請嘗試使用",
      autoImgTip6: "圖片本地化",
      autoImgTip7: "或",
      autoImgTip8: "上傳雲端儲存",
      autoImgTip9: "解決。",
      imgAlt: "圖片alt屬性",
      imgAltTip1: "使用相關長尾詞",
      imgAltTip2: "使用當前關鍵字（預設）",
      imgAltTip3: "使用文章標題",
      imgAltTip4: "空白alt屬性",
      addStart: "文章開頭新增內容",
      addStartTip1: "在",
      addStartTip2: "文章開頭",
      addStartTip3: "新增一段內容，允許使用",
      addStartTip4: "標籤，字數不超過500字。",
      addStartTip5: "文章開頭新增內容",
      addEnd: "文章末尾添加內容",
      addEndTip1: "在",
      addEndTip2: "文章末",
      addEndTip3: "追加一段內容，允許使用",
      addEndTip4: "標籤，字數不超過500字。",
      addEndTip5: "文章末尾添加內容",
      payType: "文章交付方式",
      payTypeTip1: "自動發布：透過",
      payTypeTip2: "介面檔案",
      payTypeTip3: "發佈到網站後台，發佈失敗時儲存到",
      payTypeTip4: "文章暫存庫",
      payTypeTip5: "，用於發布的介面文件請自行取得。",
      payTypeTip6: "手動發布：直接把文章放到",
      payTypeTip7: "文章暫存庫",
      payTypeTip8: "，以便手動編輯再發布或複製到其他媒體，或批量下載到本機。",
      pushTime: "文章發佈時間",
      pushTimeTip1: "生成完成立即發布",
      pushTimeTip2: "本時段內隨機時間發布",
      pushTimeTip3: "（僅限開啟自動發佈時適用）",
      pushTimeTip4: "請勾選需要運作的時段：",
      baiduPush: "百度主動推送",
      baiduPushTip1: "請填寫百度資源平台推送介面金鑰：",
      baiduPushTip2: "留空則關閉。",
      baiduPushTip3:
        "請同時將文章發布狀態設為開放瀏覽，否則百度蜘蛛可能無法抓取。",
      byPush: "必應主動推送",
      byPushTip1: "請填寫必應資源平台推送介面金鑰：",
      byPushTip2: "留空則關閉。",
      byPushTip3: "請同時將文章發佈狀態設為開放瀏覽，否則必應蜘蛛可能無法抓取。",
      pushErr: "發布失敗通知",
      pushErrTip1: "文章發布失敗時，發送站內通知給我。",
      pseudoOriginal: "標題偽原創來源",
      pseudoOriginalTip1: "百度",
      saveSet: "儲存設定",
      templateName: "模版名稱",
      operate: "操作",
      import: "導入",
      del: "刪除",
      close: "關閉",
      enterTemplateName: "請輸入儲存為範本的名稱",
      saveSuc: "保存成功",
      saveTemplateSuc: "儲存模板成功",
      importSuc: "導入成功",
      delTip: "此操作將永久刪除該模版, 是否繼續?",
      hadCancelDel: "已取消刪除",
      delSuc: "刪除成功",
      imgMust: "圖片為必選",
      titleSource: "標題來源",
      titleSourceTip1: "百度",
      titleSourceTip2: "谷歌",
      lang: "生成文章語言",
      langTip1: "中文",
      langTip2: "繁體",
      langTip3: "英文",
      googleSpiderPool: "谷歌蛛蛛池",
      googleSpiderPoolTip1: "是",
      googleSpiderPoolTip2: "否",
      googleSpiderPoolTip3: "提升收錄",
      filterTitleType: "採集的標題過濾",
      filterTitleTypeTip1: "過濾純英文",
      filterTitleTypeTip2: "過濾帶中文",
      filterTitleTypeTip3: "不過濾",
      filterTitleTypeTip4: "僅限欄目",
      filterTitleTypeTip5: "標題中綁定AI模式",
      titleInsertKeyword: "標題插入關鍵字",
      titleInsertKeywordTip1: "插入開頭",
      titleInsertKeywordTip2: "插入結尾",
      titleInsertKeywordTip3: "不插入",
      bindAi: "綁定AI版本",
      deductPoints: "本次扣除積分預覽",
      pushWeb: "綁定的程式名",
      delimiter: "分隔符",
    },
    article: {
      pushTime: "發佈時間",
      comment: "個評論",
      reply: "回覆文章請先",
      verify: "實名認證",
      promoter: "發起人",
      house: "噴沫屋",
      enterpriseCertification: "企業認證",
      ai: "雲端的AI生成更輕鬆",
      popularArticles: "熱門文章",
      generatorRelated: "生成器相關"
    },
    articleedit: {
      title: "文章標題",
      columnID: "欄位ID",
      articleContent: "文章內容",
      wysiwyg: "所見即所得編輯器",
      toolbar: "工具列",
      code: "原始碼",
      bold: "加粗",
      incline: "傾斜",
      numberedList: "編號列表",
      itemList: "項目清單",
      blockReference: "區塊引用",
      editHyperlink: "編輯超連結",
      insertVideo: "插入視頻",
      fullScreen: "全螢幕",
      press: "按",
      help: "獲得協助",
      save: "儲存",
      savePush: "儲存並發布",
      enterConter: "請輸入文章內容",
      savePushSuc: "儲存並發布成功",
      saveSuc: "保存成功",
      website: "所屬網站",
      bindAi: "綁定AI版本",
      useProgram: "使用的程式",
    },
    forgotPassword: {
      title: "找回密碼",
      email: "信箱",
      next: "下一步",
      sucTip1: "郵件已發送",
      sucTip2: "密碼重設連結已經傳送到您信箱",
      sucTip3: "請登入您的信箱並點擊密碼重設連結進行密碼更改",
      sucTip4: "如果沒有找到郵件，請嘗試查看廣告郵件、垃圾郵件等"
    },
    forgotPasswordTwo: {
      title: "找回密碼",
      newPassword: "新密碼",
      surePassword: "確認密碼",
      sure: "確認保存",
      suc: "找密碼成功"
    },
    notice: {
      title: "通知",
      more: "更多",
    },
    signup: {
      title: "帳號密碼註冊",
      account: "使用者名稱",
      passwd: "密碼",
      confirmPasswd: "重複密碼",
      mobile: "手機號",
      email: "郵件地址",
      btn: "註冊",
      suc: "註冊成功",
    },
    userWallet: {
      balance: "餘額",
      withdrawal: "提現",
      copy: "複製",
      withdrawalUrl: "推薦連結",
      referralEarning: "推薦收入",
      time: "時間",
      withdrawalAmount: "提現金額",
      withdrawalTime: "提現時間",
      enterAmount: "請輸入提現金額",
      withdrawalList: "提現列表",
      conpySuc: "複製成功",
      reference: "推薦人",
      name: "姓名",
      account: "帳號",
      recommendRate: "佣金比例",
    }
  };
  


// WEBPACK FOOTER //
// ./src/lang/zh_HK.js